import { storageService } from '@/shared/services';
import { getConfig } from '@/shared/configs';
import actions from './video.actions';
import getters from './video.getters';
import mutations from './video.mutations';

import { IVideoState } from './video.types';

const seekingMode = JSON.parse(storageService.session.get(getConfig().VIDEO_SEEKING_MODE, '{}'));

const state: IVideoState = {
  videoData: null,
  videoSourceUrl: '',
  videoThumbUrl: '',
  videoPlaysCount: seekingMode.videoPlaysCount || 0,

  allowFastForward: seekingMode.allowFastForward,
  allowFastBackward: seekingMode.allowFastBackward,
  playAtLeastOnce: false,

  quizAvailable: false,

  loading: false,
  error: false,
  hasErrors: false,
  errors: [],
};

export const videoModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
